/* eslint-disable @typescript-eslint/no-unsafe-return */
import { joinPath } from "../../utils/string";
import { SoapService, BaseEaiwsService } from "../SoapService";
import { LogData, ProjectSettings, SendMessageResult, SystemInformation } from "./SessionTypes";
export class SessionService extends BaseEaiwsService {
    constructor(pOwner, pBaseUrl, pSessionId) {
        super(pOwner, joinPath(pBaseUrl, "EAI/Session"), "http://ws.eai.egr/", pSessionId);
    }
    static GetSystemInformation(pBaseUrl, pOptions) {
        const tTempService = new SessionService(null, pBaseUrl, null);
        return (tTempService.getSystemInformation(pOptions));
    }
    static OpenSession(pBaseUrl, pArgs) {
        const tTempService = new SessionService(null, pBaseUrl, null);
        const tPromise = tTempService.soapAjax("openSession", {
            args: pArgs
        });
        return (tPromise);
    }
    closeSession() {
        const tPromise = this.soapAjax("closeSession", {
            sessionId: this.mSessionId
        });
        return (tPromise);
    }
    configureSessionLog(pEnable, pConfig) {
        const tPromise = this.soapAjax("configureSessionLog", {
            sessionId: this.mSessionId,
            enable: pEnable,
            config: pConfig
        });
        return (tPromise);
    }
    /**
     * Note: The server response will be cached to speed up further calls.
     */
    getLocale(pWithTimeZone) {
        if (this.mLocale != null)
            return (Promise.resolve(this.mLocale));
        const tPromise = this.soapAjax("getLocale", {
            sessionId: this.mSessionId,
            withTimeZone: pWithTimeZone
        }).then((pLocale) => {
            this.mLocale = pLocale;
            return (this.mLocale);
        });
        return (tPromise);
    }
    getProjectAppData(pAppKey, pPaths) {
        const tPromise = this.soapAjax("getProjectAppData", {
            sessionId: this.mSessionId,
            appKey: pAppKey == null ? "" : pAppKey,
            paths: pPaths
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    getProjectSettings() {
        const tPromise = this.soapAjax("getProjectSettings", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            return (ProjectSettings.FromSoap(pResponse));
        });
        return (tPromise);
    }
    getSessionLog(pReset) {
        const tPromise = this.soapAjax("getSessionLog", {
            sessionId: this.mSessionId,
            reset: pReset
        }).then((pResponse) => {
            return (LogData.FromSoap(pResponse));
        });
        return (tPromise);
    }
    getSessionProperty(pName) {
        const tPromise = this.soapAjax("getSessionProperty", {
            sessionId: this.mSessionId,
            name: pName
        });
        return (tPromise);
    }
    getSystemInformation(pOptions) {
        const tPromise = this.soapAjax("getSystemInformation", {
            options: pOptions
        }).then((pResponse) => {
            return (SystemInformation.FromSoap(pResponse));
        });
        return (tPromise);
    }
    getUploadURL(pFileType, pSuffix) {
        const tPromise = this.soapAjax("getUploadURL", {
            sessionId: this.mSessionId,
            fileType: pFileType,
            suffix: pSuffix
        });
        return (tPromise);
    }
    importFile(pUrl, pAttributes, pOptions) {
        const tPromise = this.soapAjax("importFile", {
            sessionId: this.mSessionId,
            url: pUrl,
            attributes: pAttributes,
            options: pOptions
        });
        return (tPromise);
    }
    keepAlive() {
        const tPromise = this.soapAjax("keepAlive", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            return (pResponse === "true");
        });
        return (tPromise);
    }
    loadEmptySession() {
        const tPromise = this.soapAjax("loadEmptySession", {
            sessionId: this.mSessionId
        }).then(() => {
            this.mOwner._clearCache();
        });
        return (tPromise);
    }
    loadSession(pUri, pOptions) {
        const tPromise = this.soapAjax("loadSession", {
            sessionId: this.mSessionId,
            uri: pUri == null ? "" : pUri,
            options: pOptions
        });
        return (tPromise);
    }
    resolveURIs(pUris, pOptions) {
        const tPromise = this.soapAjax("resolveURIs", {
            sessionId: this.mSessionId,
            uris: pUris,
            options: pOptions
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    saveSession(pUri, pOptions) {
        const tPromise = this.soapAjax("saveSession", {
            sessionId: this.mSessionId,
            uri: pUri == null ? "" : pUri,
            options: pOptions == null ? null : pOptions
        });
        return (tPromise);
    }
    sendMessage(pMessages) {
        const tPromise = this.soapAjax("sendMessage", {
            sessionId: this.mSessionId,
            messages: pMessages
        }).then((pResponse) => {
            return (SendMessageResult.FromSoap(pResponse));
        });
        return (tPromise);
    }
    setLocale(pLocale, pTimeZone, pTzOffset) {
        const tPromise = this.soapAjax("setLocale", {
            sessionId: this.mSessionId,
            name: pLocale == null ? "" : pLocale,
            timeZone: pTimeZone,
            tzOffset: pTzOffset
        }).then(() => {
            this.mLocale = undefined;
            this.mOwner.eventSessionLocaleChanged.trigger();
        });
        return (tPromise);
    }
    setProjectAppData(pAppKey, pData) {
        const tPromise = this.soapAjax("setProjectAppData", {
            sessionId: this.mSessionId,
            appKey: pAppKey == null ? "" : pAppKey,
            data: pData
        });
        return (tPromise);
    }
    setProjectSettings(pSettings) {
        const tPromise = this.soapAjax("setProjectSettings", {
            sessionId: this.mSessionId,
            settings: pSettings
        });
        return (tPromise);
    }
    setSessionProperty(pName, pValue) {
        const tPromise = this.soapAjax("setSessionProperty", {
            sessionId: this.mSessionId,
            name: pName,
            value: pValue
        });
        return (tPromise);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _clearCache() {
        this.mLocale = undefined;
    }
}
